/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Window`)
};

const es_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventana`)
};

const de_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fenster`)
};

const nl_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venster`)
};

const fr_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fenêtre`)
};

const it_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finestra`)
};

const pt_br2_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janela`)
};

const pt_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janela`)
};

const ja_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`窓`)
};

const zh_gcskew_x_axis = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`窗口`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_x_axis = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_x_axis(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_x_axis", locale)
	if (locale === "en") return en_gcskew_x_axis(inputs)
	if (locale === "es") return es_gcskew_x_axis(inputs)
	if (locale === "de") return de_gcskew_x_axis(inputs)
	if (locale === "nl") return nl_gcskew_x_axis(inputs)
	if (locale === "fr") return fr_gcskew_x_axis(inputs)
	if (locale === "it") return it_gcskew_x_axis(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_x_axis(inputs)
	if (locale === "pt") return pt_gcskew_x_axis(inputs)
	if (locale === "ja") return ja_gcskew_x_axis(inputs)
	return zh_gcskew_x_axis(inputs)
};